import React from 'react';
import {
  PieChart,
  Pie,
  Cell,
  ResponsiveContainer,
} from 'recharts';

interface StandardPieChartProps {
  data: PieData[];
  colors?: string[];
  labelLine?: boolean;
  innerRadius?: number;
  outerRadius?: number;
  dataKey?: string;
  width?: number | string;
  height?: number | string;
  onClick?: (entry: PieData, index: number) => void;
}

interface PieData {
  name: string;
  value: number;
}

const StandardPieChart: React.FC<StandardPieChartProps> = ({
  data,
  colors = ['#d3d3d3', '#a9a9a9', '#000000'],
  innerRadius,
  outerRadius,
  labelLine = true,
  dataKey = 'value',
  width = '100%',
  height = 300,
  onClick,
}) => {
  return (
    <div className="pie-chart-section" style={{ width, height }} >
      <ResponsiveContainer width="100%" height="100%">
        <PieChart>
          <Pie
            data={data}
            cx="50%"
            cy="50%"
            labelLine={labelLine}
            fill="#8884d8"
            dataKey={dataKey}
            isAnimationActive={false}
            style={{ outline: 'none' }}
            {...(innerRadius !== undefined ? { innerRadius } : {})}
            {...(outerRadius !== undefined ? { outerRadius } : {})}
            onClick={(data, index) => {
              if (onClick) {
                const clickedData = data.payload as PieData;
                onClick(clickedData, index);
              }
            }}
          >
            {data.map((entry, index) => (
              <Cell key={`cell-${index}`} fill={colors[index % colors.length]} />
            ))}
          </Pie>
        </PieChart>
      </ResponsiveContainer>
    </div>
  );
};

export default StandardPieChart;